import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#add_visit_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Add Visit Info")
  ])
], -1)
const _hoisted_3 = {
  id: "add_visit_info",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Type of Visitor", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name Of Visiting Officer", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Designation Of Visiting Officer", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Organization Of Visiting Officer", -1)
const _hoisted_19 = { class: "card mb-5 mb-xl-10" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#add_visit_info2",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Visit Information")
  ])
], -1)
const _hoisted_21 = {
  id: "add_visit_info2",
  class: "collapse show"
}
const _hoisted_22 = { class: "collapse show" }
const _hoisted_23 = { class: "card-body border-top p-9" }
const _hoisted_24 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name of Visited Association/Partner", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Name Of the Institute Visited", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Address of the Institute Visited", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-3 mt-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Visited Date From", -1)
const _hoisted_39 = { class: "col-md-3 mt-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Visited Date To", -1)
const _hoisted_41 = { class: "col-md-3 mt-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Report Submission Date", -1)
const _hoisted_43 = { class: "col-md-3 mt-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Visit Type", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = ["data-kt-indicator"]
const _hoisted_47 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_48 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_49 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_Form, {
    class: "form",
    onSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formSubmit())),
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Type of Visitor",
                      modelValue: _ctx.batch.visitor_type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.visitor_type) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.getEmployee
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitorType, (type) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: type.id,
                            label: type.name,
                            value: type.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(type.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Type of Visitor",
                      modelValue: _ctx.batch.visiting_officer,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.visiting_officer) = $event)),
                      filterable: "",
                      onChange: _ctx.getRole,
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info?.employee.id,
                            label: info?.employee.name,
                            value: info?.employee.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info?.employee.name) + "(" + _toDisplayString(info?.entity_info.entity_short_name) + ")", 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.role_name) = $event)),
                      type: "text",
                      name: "role_name",
                      class: "form-control",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.role_name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visitor_entity_name) = $event)),
                      type: "text",
                      name: "",
                      class: "form-control",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.visitor_entity_name]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _hoisted_28,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Type of Visitor",
                      modelValue: _ctx.visited.entity,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visited.entity) = $event)),
                      onChange: _ctx.getTrainingInstitute,
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("[" + _toDisplayString(info.entity_short_name) + "]-" + _toDisplayString(info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _hoisted_31,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.visited.institute,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visited.institute) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.getInsituteDetails
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.institute_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128)),
                        _createVNode(_component_el_option, {
                          label: "Other",
                          value: "-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Other")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    (_ctx.showInstituteInput)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visited.institute_name) = $event)),
                          type: "text",
                          name: "",
                          class: "form-control"
                        }, null, 512)), [
                          [_vModelText, _ctx.visited.institute_name]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visited.institute_address) = $event)),
                      type: "text",
                      name: "",
                      class: "form-control",
                      disabled: _ctx.disabled == 1
                    }, null, 8, _hoisted_35), [
                      [_vModelText, _ctx.visited.institute_address]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.visited.visit_date_from,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visited.visit_date_from) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            style: {"width":"100%"},
                            type: "date",
                            name: "bill_date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.visited.visit_date_to,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visited.visit_date_to) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            style: {"width":"100%"},
                            type: "date",
                            name: "bill_date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.visited.report_submission_date,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visited.report_submission_date) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            style: {"width":"100%"},
                            type: "date",
                            name: "bill_date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _hoisted_45,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Visit Type",
                        modelValue: _ctx.batch.visit_type,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.batch.visit_type) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Surprise Visit",
                            value: "Surprise"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Surprise Visit")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Regular Visit",
                            value: "Regular"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Regular Visit")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inqueray Visit",
                            value: "Inqueray"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inqueray Visit")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          "data-kt-indicator": _ctx.loading ? 'on' : null,
          class: "btn btn-lg btn-success",
          type: "submit"
        }, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                _createTextVNode(" Submit "),
                _createElementVNode("span", _hoisted_48, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                _createTextVNode(" Please wait... "),
                _hoisted_50
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_46)
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"])), [
    [_directive_loading, _ctx.load]
  ])
}